import React from 'react';
import { mapConfig } from './mapConfig';

interface RadiusControlProps {
  searchRadius: number;
  onRadiusChange: (radius: number) => void;
  translations?: Record<string, string>;
}

const RadiusControl: React.FC<RadiusControlProps> = ({ searchRadius, onRadiusChange, translations = {} }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onRadiusChange(Number(e.target.value));
  };

  return (
    <div className="radius-control">
      <h3>{translations["place.searchRadius"]}</h3>
      <div className="radius-slider">
        <input
          type="range"
          min={mapConfig.minRadius}
          max={mapConfig.maxRadius}
          step="500"
          value={searchRadius}
          onChange={handleChange}
          className="slider"
        />
        <span className="radius-value">
          {searchRadius >= 1000
            ? `${(searchRadius / 1000).toFixed(1)} km`
            : `${searchRadius} m`}
        </span>
      </div>
    </div>
  );
};

export default RadiusControl;